import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class DividentService {

  constructor( private httpService: HttpService) { }

  addDividendMandateData(object) {
    var request = {
      URL: "dividendMandate/add",
      DATA: object
    }
    return this.httpService.post(request);
  }


  getDividendMandateList(object) {
    var request = {
      URL: "dividendMandate/getList",
      DATA: object
    }
    return this.httpService.post(request);
  }

  getDividendMandateById(id) {
    var request = {
      URL: 'dividendMandate/edit/' + id
    }
    return this.httpService.get(request);
  }

  updateDividendMandate(object,id) {
    var request = {
      URL: "dividendMandate/update/"+id,
      DATA: object
    }
    return this.httpService.post(request);
  }

  deleteDividendMandate(id) {
    var request = {
      URL: "dividendMandate/delete/" + id
    }
    return this.httpService.get(request);
  }

  generateDividendMandateDocument(object) {
    var request = {
        URL: "dividendMandate/generateDividendMandateDocument",
        DATA: object
    }
    return this.httpService.post(request);
}

downloadDividendMandateFile(id, type) {
  var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + "dividendMandate/downloadDocument/" + id + "/" + type + "/" + token;
}

downloadDividendMandatePdfFile(id, type) {
  var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + "dividendMandate/downloadPdfDocument/" + id + "/" + type + "/" + token;
}

}
